import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostAgentMonthManageBonusDtlList } from '@/services/wms/commission';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        agentId: this.$route.query.agentId,
        month: this.$route.query.month,
        year: this.$route.query.year
      },
      btnLoading: false,
      listRequest: rqtPostAgentMonthManageBonusDtlList,
      codeResItems: [{
        title: '封闭期单位',
        dataIndex: 'closePeriodUnit',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'closePeriodUnit'
      }, {
        title: '回访状态',
        dataIndex: 'callBackStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'callBackStatus'
      }]
    };
  },
  computed: {},
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {}
};